/**
 * WEB TEMASI RENKLERİ — WarmBreak tasarım sistemi (yetkili kaynak
 * `docs/design/yeni-gorunum/tokens.json`, sürüm 1793359729-b05b).
 *
 * Mobil de bu tabloyu okur, yalnız `../mobil-tema` kapısından (mobil yeni
 * görünüm M0; eski `../tokens.ts` mobil için emekli). Kapılar:
 *   · `web-tema-tasarim-esleme.guard.spec.ts` (packages/ui) 50 ad × 2 tema
 *     değerini tokens.json ile karşılaştırır.
 *   · `mobil-tema-donmus.guard.spec.ts` mobil temasını tokens.json ile
 *     karşılaştırır.
 *   · `mobil-web-tema-siniri.guard.spec.ts` mobilin bu klasöre yalnız kapıdan
 *     ulaştığını denetler.
 *
 * İki bölüm vardır: TASARIM ADLARI (tokens.json'daki 50 ad, aynen) ve ESKİ WEB
 * ANAHTARLARI (bugün CSS modüllerinin okuduğu, tasarımda karşılığı olmayan
 * adlar). Eski anahtarın değeri tasarım adından gelir, kaynağı ve emekli
 * olacağı tur `eski-anahtarlar.ts` tablosundadır.
 */
export const WEB_DESIGN_COLOR_NAMES = [
    'background',
    'surface',
    'surfaceRaised',
    'surfaceSunken',
    'border',
    'borderStrong',
    'sectionDivider',
    'textPrimary',
    'textSecondary',
    'textTertiary',
    'textDisabled',
    'textOnPrimary',
    'textOnAccent',
    'primary',
    'primaryHover',
    'primaryActive',
    'primarySubtle',
    'primaryBorder',
    'primaryStrong',
    'accent',
    'accentHover',
    'accentSoft',
    'accentSubtle',
    'accentBorder',
    'accentStrong',
    'focusRing',
    'focusRingOnInk',
    'success',
    'successSubtle',
    'warning',
    'warningSubtle',
    'info',
    'infoSubtle',
    'danger',
    'dangerSubtle',
    'band',
    'textOnBand',
    'textOnBandSecondary',
    'dangerFill',
    'dangerFillHover',
    'textOnDanger',
    'accentActive',
    'overlay',
    'chart1',
    'chart2',
    'chart3',
    'chart4',
    'chart5',
    'chart6',
    'focusRingOnBand',
];
export const webDesignLight = {
    background: '#FFFFFF',
    surface: '#F5F3FC',
    surfaceRaised: '#FFFFFF',
    surfaceSunken: '#ECE8F7',
    border: '#DCD7EA',
    borderStrong: '#807897',
    sectionDivider: '#EEEBF8',
    textPrimary: '#1C172B',
    textSecondary: '#574F6C',
    textTertiary: '#605877',
    textDisabled: '#A9A3BC',
    textOnPrimary: '#FFFFFF',
    textOnAccent: '#FFFFFF',
    primary: '#3A13AE',
    primaryHover: '#31109A',
    primaryActive: '#270C7D',
    primarySubtle: '#EEE9FD',
    primaryBorder: '#6A4BD0',
    primaryStrong: '#270C7D',
    accent: '#6C7B24',
    accentHover: '#5E6B1F',
    accentSoft: '#DDE5B5',
    accentSubtle: '#F2F5E1',
    accentBorder: '#7D8E2A',
    accentStrong: '#56631C',
    focusRing: '#3A13AE',
    focusRingOnInk: '#FFFFFF',
    success: '#1A7346',
    successSubtle: '#E2F3E9',
    warning: '#8A5600',
    warningSubtle: '#FFF0D4',
    info: '#1F5E95',
    infoSubtle: '#E3EEF8',
    danger: '#C0352B',
    dangerSubtle: '#FDE8E6',
    band: '#A68CF2',
    textOnBand: '#16171A',
    textOnBandSecondary: '#2E2645',
    dangerFill: '#C0352B',
    dangerFillHover: '#A12B22',
    textOnDanger: '#FFFFFF',
    accentActive: '#515C1A',
    overlay: 'rgba(28, 23, 43, 0.48)',
    chart1: '#3A13AE',
    chart2: '#6C7B24',
    chart3: '#B9A6F5',
    chart4: '#1E8A8A',
    chart5: '#E8B230',
    chart6: '#A23B6B',
    focusRingOnBand: '#16171A',
};
export const webDesignDark = {
    background: '#121019',
    surface: '#191623',
    surfaceRaised: '#221E2F',
    surfaceSunken: '#0C0B12',
    border: '#322C44',
    borderStrong: '#7A7193',
    sectionDivider: '#272137',
    textPrimary: '#EEEAF7',
    textSecondary: '#B3AACB',
    textTertiary: '#9C93B5',
    textDisabled: '#5E5674',
    textOnPrimary: '#16171A',
    textOnAccent: '#16171A',
    primary: '#A68CF2',
    primaryHover: '#B5A0F5',
    primaryActive: '#C5B5F8',
    primarySubtle: '#2A2148',
    primaryBorder: '#8C70E6',
    primaryStrong: '#CFC2FA',
    accent: '#A3B83C',
    accentHover: '#B1C54C',
    accentSoft: '#3A4216',
    accentSubtle: '#222710',
    accentBorder: '#8A9D33',
    accentStrong: '#C2D46A',
    focusRing: '#C2AEF8',
    focusRingOnInk: '#16171A',
    success: '#5CC98F',
    successSubtle: '#123528',
    warning: '#F2B94B',
    warningSubtle: '#3A2C10',
    info: '#7DB8E8',
    infoSubtle: '#132F47',
    danger: '#FF8A7E',
    dangerSubtle: '#3D1A18',
    band: '#A68CF2',
    textOnBand: '#16171A',
    textOnBandSecondary: '#2E2645',
    dangerFill: '#C93A2F',
    dangerFillHover: '#B23026',
    textOnDanger: '#FFFFFF',
    accentActive: '#BFD160',
    overlay: 'rgba(5, 4, 10, 0.72)',
    chart1: '#A68CF2',
    chart2: '#A3B83C',
    chart3: '#DCD2FB',
    chart4: '#4CC0C0',
    chart5: '#F2C14E',
    chart6: '#E27BA8',
    focusRingOnBand: '#16171A',
};
//# sourceMappingURL=renkler.js.map